import React, { useMemo, useState, useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { Row, Col } from "antd";

import Service from "./service";
import InputItem from "../../app/generic/inputItem";

const NationalTransportId = ({
  disabled,
  pickupCountry,
  formItemLayout,
  initialServices,
  deliveryCountry,
  getFieldDecorator,
}) => {
  const poland = deliveryCountry && deliveryCountry.code === "PL",
    hungary = deliveryCountry && deliveryCountry.code === "HU",
    romania =
      (deliveryCountry && deliveryCountry.code === "RO") ||
      (pickupCountry && pickupCountry.code === "RO");

  const initNationalTransportIdFree = useMemo(
    () => initialServices && initialServices.nationalTransportId === "",
    [initialServices]
  );
  const [nationalTransportIdFree, setNationalTransportIdFree] = useState(
    initNationalTransportIdFree
  );
  const handleNationalTransportIdFreeChange = useCallback(({ target }) => {
    setNationalTransportIdFree(target.checked);
  }, []);

  return poland || hungary || romania ? (
    <Row type="flex" align="middle">
      <Service
        hideRow
        span={8}
        disabled={disabled}
        label={
          hungary ? (
            <FormattedMessage
              id="consignment.services.ekaerFree"
              defaultMessage="EKAER free"
            />
          ) : poland ? (
            <FormattedMessage
              id="consignment.services.sentFree"
              defaultMessage="SENT free"
            />
          ) : (
            <FormattedMessage
              id="consignment.services.uitFree"
              defaultMessage="UIT free"
            />
          )
        }
        fieldName="nationalTransportIdFree"
        getFieldDecorator={getFieldDecorator}
        initialValue={initNationalTransportIdFree}
        onChange={handleNationalTransportIdFreeChange}
      />
      <Col span={16}>
        {!nationalTransportIdFree && (
          <InputItem
            allowClear
            maxLength={20}
            wrapperCol={7}
            disabled={disabled}
            label={
              hungary ? (
                <FormattedMessage
                  id="consignment.services.ekaer"
                  defaultMessage="EKAER"
                />
              ) : poland ? (
                <FormattedMessage
                  id="consignment.services.sent"
                  defaultMessage="SENT"
                />
              ) : (
                <FormattedMessage
                  id="consignment.services.uit"
                  defaultMessage="UIT"
                />
              )
            }
            message={
              hungary ? (
                <FormattedMessage
                  id="consignment.services.ekaer.empty"
                  defaultMessage="Zadejte prosím EKAER"
                />
              ) : poland ? (
                <FormattedMessage
                  id="consignment.services.sent.empty"
                  defaultMessage="Zadejte prosím SENT"
                />
              ) : (
                <FormattedMessage
                  id="consignment.services.uit.empty"
                  defaultMessage="Zadejte prosím UIT"
                />
              )
            }
            fieldName="nationalTransportId"
            formItemLayout={formItemLayout}
            getFieldDecorator={getFieldDecorator}
            initialValue={
              initialServices && initialServices.nationalTransportId
            }
          />
        )}
      </Col>
    </Row>
  ) : (
    <></>
  );
};

export default NationalTransportId;
